import { Component, OnInit, TemplateRef } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { SWAlertService } from '../../services/swalert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/ngx-bootstrap-typeahead';
import * as _ from 'lodash';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-svmreport',
  templateUrl: './svmreport.component.html',
  styleUrls: ['./svmreport.component.css']
})
export class SVMReportComponent implements OnInit {
  data: any;
  arrCompany: any[] = [];
  arrStatus: any[] = [];
  arrPaytype: any[] = [];
  arrTreq: any[] = [];
  arrDataTreq: any[] = [];
  arrCurrency: any[] = [];
  settings_PayType = {};
  settings_com = {};
  settings_Status = {};


  txtPaytype: any[] = [];
  txtstatus: any[] = [];
  txtCom: any[] = [];
  sCom: any[] = [];
  status: any[] = [];
  txtCurrency: string = null;
  sPaytype: any[] = [];
  IsCom: boolean = false;
  IsPaytype: boolean = false;
  txtrangDate: any[] = [];
  IsReqNo1: boolean = false;
  IsReqNo2: boolean = false;
  txtReqNo1: string = null;
  txtReqNo2: string = null;
  sReqNo1: string = null;
  sReqNo2: string = null;
  modalRef: BsModalRef;
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 }
    ]
  }
  _ArrData: any;
  _ArrDatatotal: any[] = [];
  _ArrDatatotalBind: any[] = [];
  //Set grid
  _ArrDataBind = [];
  sDetailData = "";
  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortAsc = "fas fa-sort-up";
  IcoSortDesc = "fas fa-sort-down";
  minDate: Date = new Date();
  maxDate: Date = new Date();
  //Head colums
  Columns = [
    { ColumnName: "Request No.", SortField: "sRequestCode", Width: "120px" },
    { ColumnName: "Request Date", SortField: "dRequestDate", Width: "120px" },
    { ColumnName: "Status", SortField: "sStatusName_SSC", Width: "150px" },
    { ColumnName: "Due Date", SortField: "dDueDate", Width: "110px" },
    { ColumnName: "Vendor Code", SortField: "VENDOR_CODE", Width: "150px" },
    { ColumnName: "Vendor Name", SortField: "VENDORNAME", Width: "180px" },
    { ColumnName: "Payment Type", SortField: "sReqType", Width: "150px" },
    { ColumnName: "Currency", SortField: "sCurrency", Width: "100px" },
    { ColumnName: "Amount excl. VAT", SortField: "nGrandTotalAmt", Width: "200px" },
    { ColumnName: "VAT", SortField: "nGrandTotalAmtVat", Width: "200px" },
    { ColumnName: "Amount incl. VAT", SortField: "nGrandTotalAmtInvoice", Width: "200px" },
    { ColumnName: "Description", SortField: "sInvoiceDesc", Width: "150px" },
    { ColumnName: "UG", SortField: "nSSCUrgent", Width: "50px" },
    { ColumnName: "Invoice Amount", SortField: "nInvoiceAmount", Width: "120px" },
    { ColumnName: "Receipt No.", SortField: "sInvoiceNo", Width: "120px" },
    { ColumnName: "Invoice Date", SortField: "dInvoiceDate", Width: "120px" },
    { ColumnName: "Type", SortField: "sVATType", Width: "120px" },
    { ColumnName: "GL", SortField: "sGL", Width: "120px" },
    { ColumnName: "Cost Center", SortField: "sCCTR", Width: "120px" },
    { ColumnName: "IO", SortField: "sIO", Width: "120px" },
    { ColumnName: "Amount", SortField: "nAmtIncldVAT", Width: "120px" },
    { ColumnName: "Cur", SortField: "sCurrency2", Width: "120px" },
    { ColumnName: "Description", SortField: "sText", Width: "120px" },
    { ColumnName: "FI Doc", SortField: "sFIDoc", Width: "120px" },
    { ColumnName: "Clearing Doc", SortField: "sClearingDoc", Width: "120px" },
    { ColumnName: "Advance Clearing Doc", SortField: "sAdvClearingDoc", Width: "120px" },
    { ColumnName: "Receive Doc", SortField: "sRecieveDoc", Width: "120px" },
    { ColumnName: "RO Submit Date", SortField: "dROSubmitDateTime", Width: "120px" },
    { ColumnName: "RO Submit Time", SortField: "dROSubmitDateTime", Width: "120px" },
    { ColumnName: "Approver 2 Name", SortField: "sApprove", Width: "120px" },
    { ColumnName: "Approver 2 Date", SortField: "dApprove", Width: "120px" },
    { ColumnName: "Paid Doc No. ", SortField: "sPaymentDoc", Width: "150px" },
    { ColumnName: "Received to SSC Date (Waiting SSC)", SortField: "dReceivingDocDate", Width: "120px" },
    { ColumnName: "Export to SAP Date", SortField: "dExportToSAP", Width: "100px" },
    { ColumnName: "Number of Days Processing ", SortField: "nDate", Width: "100px" },
    { ColumnName: "User Name (RO)", SortField: "Requester", Width: "200px" },
    { ColumnName: "User Name (SSC)", SortField: "FullName", Width: "200px" },
    { ColumnName: "", SortField: "", Width: "30px" },
  ]

  ColumnSUM = [
    { ColumnName: "Summary", SortField: "", Width: "20%" },
    { ColumnName: "Total Amount", SortField: "", Width: "50%" },
    { ColumnName: "Count Number of Transactions", SortField: "", Width: "30%" },
  ]

  constructor(private http: HttpClient
    , private formBuilder: FormBuilder
    , private SW: SWAlertService
    , private activatedRoute: ActivatedRoute
    , private router: Router
    , private System: TSFuntionService
    , private modalService: BsModalService) { }

  ngOnInit() {
    this.getAutocomplete();
    this.settings_PayType = {
      singleSelection: false,
      idField: 'nReqType',
      textField: 'sReqType',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_com = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_Status = {
      singleSelection: false,
      idField: 'nStatusID',
      textField: 'sStatusName_SSC',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };

    const ua = this.System.GetUserStorage();
    if (ua) {
      this.txtCom = [];
      this.sCom = [];
      ua.lstCompCode.forEach(f =>
        {
          this.txtCom.push({COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName})
          this.sCom.push(f.sCompCode)
        }
      );
    }

    let nsize = document.getElementById('dvbtn').offsetWidth;
    let width = "width:" + nsize + "px";
    document.getElementById('dvtable2').setAttribute("style", width);
    document.getElementById('tbExample').setAttribute("style", "width:2800px");
    this.minDate.setDate(this.minDate.getDate() - 90);
    this.maxDate.setDate(this.maxDate.getDate());
    this.txtrangDate = [this.minDate, this.maxDate];
    this.System.UnBlockUI();
  }


  getAutocomplete() {
    this.System.BlockUI();
    this.http.get<any>(this.System.SiteName + "api/SVMReport/getAutoData").toPromise().then(res => {
      this.System.UnBlockUI();
      this.data = res;
      const ua = this.System.GetUserStorage();
      if ([3, 4, 5].includes(ua.nRole)) {
        this.arrCompany = this.data.lstCompany.filter(f => f.COMPANY_CODE === ua.sCompCode);
      }
      else {
        this.arrCompany = this.data.lstCompany;
      }
      this.arrPaytype = this.data.lstPayType;
      this.arrDataTreq = this.data.lstTreq2;
      this.arrTreq = this.data.lstTreq2;
      this.arrCurrency = this.data.lstCurrency;
      this.txtCurrency = null;
      this.arrStatus = JSON.parse(this.data.lstStatus);
    });
  }

  onselectpaytype(item: any, name: any) {
    let _this = this;
    if (name == 'txtPaytype') {
      let npaytype = this.txtPaytype.map(f => Number.parseInt(f.nReqType))
      this.arrTreq = this.data.lstTreq2.filter(function (index) { return npaytype.includes(index.nReqType) });
    }
    if (name == 'txtCom') {
      this.sCom = this.txtCom.map(f => f.COMPANY_CODE)
      this.arrTreq = this.arrDataTreq.filter(function (index) { return _this.sCom.includes(index.sCompCode) });
    }
    if (name == 'txtstatus') {
      this.status = this.txtstatus.map(f => f.nStatusID);
    }
  }

  onSelectAll(item: any, name: any) {
    let _this = this;
    if (name == 'txtCom') {
      this.sCom = item.map(f => f.COMPANY_CODE)
      this.arrTreq = this.arrDataTreq.filter(function (index) { return _this.sCom.includes(index.sCompCode) });
    }
    if (name == 'txtPaytype') {
      let npaytype = item.map(f => Number.parseInt(f.nReqType))
      this.arrTreq = this.data.lstTreq2.filter(function (index) { return npaytype.includes(index.nReqType) });
    }
    if (name == 'txtstatus') {
      this.txtstatus = this.arrStatus;
      this.status = this.txtstatus.map(f => f.nStatusID);
    }
  }

  DeSelect(item: any, name: any) {
    let _this = this;
    if (name == 'txtCom') {
      let com = item.COMPANY_CODE
      this.sCom = this.sCom.filter(function (index) { return !com.includes(index) });
      this.arrTreq = this.arrDataTreq.filter(function (index) { return _this.sCom.includes(index.sCompCode) });
    }
    if (name == 'txtPaytype') {
      let npaytype = item.nReqType
      this.arrTreq = this.data.lstTreq2.filter(function (index) { return !npaytype.includes(index.nReqType) });
    }
    if (name == 'txtstatus') {
      this.status = this.txtstatus.map(f => f.nStatusID);
    }
  }

  onDeSelectAll(item: any, name: any) {
    let _this = this;
    if (name == 'txtCom') {
      this.sCom = []
    }
    if (name == 'txtPaytype') {
      this.txtPaytype = [];
    }
    if (name == 'txtstatus') {
      this.txtstatus = [];
    }
    this.arrTreq = this.arrDataTreq;
  }

  typeaheadNoResults(event, index) {
    switch (index) {
      case "txtCom":
        this.IsCom = event;
        break
      case "txtPreparer":
        this.IsPaytype = event;
        break
      case "txtReqNo1":
        this.IsReqNo1 = event;
        break
      case "txtReqNo2":
        this.IsReqNo2 = event;
        break
    }
  }

  typeaheadOnBlur(event: TypeaheadMatch, index) {
    var pass = true
    switch (index) {
      case "txtPreparer":
        if (this.IsPaytype) {
          this.txtPaytype = null;
        }
        if (this.txtPaytype.length != 0) {
          this.txtPaytype = [];
          this.sPaytype = [];
        }
        break
      case "txtReqNo1":
        if (this.txtReqNo1 != event.value) {
          pass = false
        }
        if (pass) {
          this.onSelect(event, index);
        } else {
          this.txtReqNo1 = null;
          this.sReqNo1 = null;
        }

        break
      case "txtReqNo2":
        if (this.txtReqNo2 != event.value) {
          pass = false
        }
        if (pass) {
          this.onSelect(event, index);
        } else {
          this.txtReqNo2 = null;
          this.sReqNo2 = null;
        }

        break

    }
  }
  onSelect(event: TypeaheadMatch, index) {
    switch (index) {
      case "txtCom":
        this.sCom = event.item.COMPANY_CODE;
        this.arrTreq = this.arrTreq.filter(f => f.sCompCode == this.sCom);
        break
      case "txtReqNo1":
        this.sReqNo1 = event.item.sRequestCode;
        break
      case "txtReqNo2":
        this.sReqNo2 = event.item.sRequestCode;
        break
    }
  }

  OnClear() {
    this.txtCom = [];
    this.txtReqNo1 = null;
    this.txtReqNo2 = null;
    this.txtPaytype = [];
    this.txtrangDate = [];
    this._ArrDataBind = [];
    this._ArrDatatotalBind = [];
    this.sReqNo1 = null;
    this.sReqNo2 = null;
    this.sCom = [];
    this.txtCurrency = null;
    this.txtrangDate = [this.minDate, this.maxDate];
    this.txtstatus = [];
    this.status = [];
    const ua = this.System.GetUserStorage();
    if (ua) {
      ua.lstCompCode.forEach(f =>
      {
        this.txtCom.push({COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName})
        this.sCom.push(f.sCompCode)
      }
      );
    }
  }

  Onsearch() {
    this.System.BlockUI();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    let arrType = this.txtPaytype.map(f => f.nReqType)
    let data = {
      arrComcode: this.sCom
      , sReqNo1: this.sReqNo1
      , sReqNo2: this.sReqNo2
      , arrpaytype: arrType
      , RangDate: this.txtrangDate
      , sCurrency: this.txtCurrency == "null" ? null : this.txtCurrency
      , arrStatus: this.status
    }
    let ITEM = JSON.stringify(data)

    this._ArrDatatotalBind = [];
    this.http.post(this.System.SiteName + 'api/SVMReport/searchData', ITEM, { headers, responseType: 'json' }).subscribe(res => {
      this.System.UnBlockUI();
      var data = res;
      this._ArrData = [];
      this._ArrDatatotalBind = [];
      if (data[0]) {
        this._ArrData = JSON.parse(data[0]);
        let arrtotal: any[] = JSON.parse(data[1]);

        let arr_UG = arrtotal.filter(f => f.IsSSCUrgent == true);
        let arr_nonUG = arrtotal.filter(f => f.IsSSCUrgent != true);
        //===================set table total=============================//
        let totalnonUG = 0
        let totalUG = 0;
        let countUG = 0;
        let countnonUG = 0;
        for (var i = 0; i < arr_UG.length; i++) {
          totalUG = totalUG + arr_UG[i].UG;
          countUG = countUG + arr_UG[i].ItemCount;
        }
        for (var i = 0; i < arr_nonUG.length; i++) {
          totalnonUG = totalnonUG + arr_nonUG[i].non_UG;
          countnonUG = countnonUG + arr_nonUG[i].ItemCount;
        }
        let total = totalUG + totalnonUG;
        let count = countnonUG + countUG;
        let _arr: any[] = [totalUG, totalnonUG, total];
        let _arrcount: any[] = [countUG, countnonUG, count];
        var arr: any[] = ["UG", "Non-UG", "Total transactions"];
        for (var i = 0; i < arr.length; i++) {
          this._ArrDatatotalBind.push({ sName: arr[i], total: _arr[i], count: _arrcount[i] })
        }

      }
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });
  }

  ExportExcel() {
    const link = document.createElement('a');
    link.target = '_blank'
    link.href = this.System.SiteName + "api/SVMReport/CreateReportExpected";
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  BindDataTable() {
    this.OptionGrid.nTotalItem = this._ArrData.length;

    let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * this.OptionGrid.nPageSize;
    let nEndIndex_Take = this.OptionGrid.nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({
      sReqUG: val.IsReqUrgent == true ? "UG" : null
      , sUG: val.IsSSCUrgent == true ? "UG" : null
    }, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);

    let nStartItemPage = nStartIndex_Take + 1;
    let nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + this._ArrData.length + " Rows";
  }

  //#region Event
  //Event ตอนกด Click Header
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      }
      else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(this._ArrData, [SortField], [this.SortDirection]);
      this.BindDataTable();
    }
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });

  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }

  //#endregion

  sReqID: any;
  ArrTran: any[] = [];
  openModal(template: TemplateRef<any>, sReqID: any) {
    this.sReqID = sReqID;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sReqID', sReqID)
    };
    this.http.get<any>(this.System.SiteName + "api/SVMReport/GetLog", httpOptions).subscribe(res => {
      if (res) {
        this.ArrTran = res;
        this.modalRef = this.modalService.show(
          template,
          Object.assign({}, { class: 'gray modal-lg' })
        );
      }

    })

  }
}
